import React from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
  TextArea,
} from "reactstrap"
function ContactDetails(props) {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Contact Details</CardTitle>

        <Form>
          <div className="row mb-4">
            <Col xs={4} sm={2} md={2} lg={4}>
              <Label className="col-form-label">Mobile Number</Label>
            </Col>
            <Col xs={8} sm={10} md={10} lg={8}>
              <p className="text-muted fw-medium col-form-label">
                {props.userData.phone_number}
              </p>
            </Col>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default ContactDetails
